<template>
  <fragment>
    <div class="sub-total-card">
      <div class="mb-3">
        <span class="sub-total">{{ $t('message.subTotal') }}</span>
        <span class="sub-total-value">${{isNaN(subTotal) ? "" : Number(subTotal).toLocaleString(number_format_locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
      </div>
      <div class="mb-3">
        <span class="sub-total">{{ $t('message.serviceFee') }}</span>
        <span class="sub-total-value">${{isNaN(service_fee) ? "" : Number(service_fee).toLocaleString(number_format_locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
      </div>
      <div v-if="taxType !== ''" class="mb-3">
        <span class="sub-total">{{ $t('message.tax') }}</span>
        <span class="sub-total-value">${{isNaN(taxValue) ? "" : Number(taxValue).toLocaleString(number_format_locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
      </div>
    </div>
    <div class="total-card mb-3">
      <div>
        <span class="sub-total">{{ $t('message.total') }}</span>
      </div>
      <div>
        <span class="sub-total">{{isNaN(points) ? "" : Math.floor(Number(points)).toLocaleString() }} points</span>
      </div>
    </div>
    <div class="total-card-value mb-3">
      <span> ${{ isNaN(total) ? "" : Number(total).toLocaleString(number_format_locale, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} </span>
    </div>
  </fragment>
</template>

<script>
export default {
  props: ["subTotal", "hst", "service_fee", "points", "total", "number_format_locale", "taxType", "taxValue"],
  name: "total-order-card-web",
};
</script>

<style lang="scss" scoped>
.sub-total {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #687888;
}
.sub-total-value {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  float: right;
  color: #45505b;
}
.sub-total-card {
  margin: 15px 0 15px 0;
  border-bottom: 1px solid #c1c8cf;
}
.total-card {
  width: 90px;
  height: 40px;
  display: inline-block;
}
.total-card-value {
  float: right;
}
.total-card-value span {
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 32px;
  display: flex;
  align-items: flex-end;
  text-align: right;
  letter-spacing: -0.1px;
  color: var(--success);
  padding-top: 15px;
}
</style>